import { useUser } from '@clerk/clerk-react'

export interface CurrentUser {
  /** Best display name available: full name → username → email → fallback. */
  name: string
  /** Primary email, or null when Clerk has none / it would just repeat `name`. */
  email: string | null
  /** Profile picture URL only when the user actually uploaded one; otherwise
   *  null so the caller falls back to the initial-letter avatar. Clerk always
   *  returns a generated placeholder in `imageUrl`, so `hasImage` is the gate. */
  imageUrl: string | null
}

/**
 * Identity of the signed-in Clerk user, shaped for the sidebar / topbar
 * footer. Rendered only inside the authenticated shell, so `user` is
 * normally loaded; the fallback name just covers the first paint.
 */
export function useCurrentUser(): CurrentUser {
  const { user } = useUser()
  const email = user?.primaryEmailAddress?.emailAddress ?? null
  const name = user?.fullName?.trim() || user?.username || email || 'Usuário'
  return {
    name,
    email: email && email !== name ? email : null,
    imageUrl: user?.hasImage ? user.imageUrl : null,
  }
}
